import { Switch } from '@mui/material';
import React from 'react';

import { CustomReactIconSwitchStyled, CustomSVGIconSwitchStyled } from './custom-icons-switch.styled.ts';
import { CustomIconsSwitchProps } from './duck';

const CustomIconSwitch: React.FC<
  CustomIconsSwitchProps & Omit<React.ComponentProps<typeof Switch>, keyof CustomIconsSwitchProps>
> = (props) => {
  const { checkedIcon, uncheckedIcon, ...otherProps } = props;

  if (typeof checkedIcon === 'string' || typeof uncheckedIcon === 'string') {
    return <CustomSVGIconSwitchStyled {...props} />;
  }

  return (
    <CustomReactIconSwitchStyled
      {...otherProps}
      icon={React.isValidElement(uncheckedIcon) ? uncheckedIcon : undefined}
      checkedIcon={React.isValidElement(checkedIcon) ? checkedIcon : undefined}
    />
  );
};

export default CustomIconSwitch;